import { createI18n } from "vue-i18n";
import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import pt from "./pt.json";//brazilian portugese
import nl from "./nl.json";

const supportedLocales: Record<string, any> = {
  en,
  de,
  fr,
  nl,
  pt,
  "pt-BR": pt,
};

type NavigatorLocaleSource = {
  language?: string;
  languages?: readonly string[];
};

function toSupportedLocale(candidate?: string | null): string | null {
  if (!candidate) return null;

  try {
    const canonical = Intl.getCanonicalLocales(candidate)[0];
    if (supportedLocales[canonical]) return canonical;

    const base = canonical.split("-")[0];
    if (supportedLocales[base]) return base;
  } catch {
    const base = candidate.split("-")[0];
    if (supportedLocales[base]) return base;
  }

  return null;
}

export function resolveLocale(
  navigatorSource: NavigatorLocaleSource | undefined =
    typeof navigator === "undefined" ? undefined : navigator
): string {
  const candidates = navigatorSource?.languages?.length
    ? navigatorSource.languages
    : navigatorSource?.language
      ? [navigatorSource.language]
      : ["en"];

  for (const candidate of candidates) {
    const resolved = toSupportedLocale(candidate);
    if (resolved) return resolved;
  }

  return "en";
}

export const locale = resolveLocale();

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  fallbackLocale: "en",
  messages: supportedLocales,
});

export function switchLanguage(newLocale: string) {
  const base = newLocale.split("-")[0];
  const resolved = supportedLocales[newLocale]
    ? newLocale
    : supportedLocales[base]
      ? base
      : null;

  if (!resolved) {
    console.warn(`Locale ${newLocale} is not supported.`);
    return;
  }
  i18n.global.locale.value = resolved;
}
